import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { siteInfo } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="footer">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#C9A96E] to-[#A67B5B] flex items-center justify-center">
                <span className="text-white font-bold text-xl font-serif">MB</span>
              </div>
              <div>
                <h3 className="text-xl font-serif font-bold text-white">{siteInfo.name}</h3>
                <p className="text-xs text-[#C9A96E] tracking-wider uppercase">{siteInfo.tagline}</p>
              </div>
            </div>
            <p className="text-[#D4C4B5] text-sm leading-relaxed mb-6">
              Votre institut de beauté spécialisé dans la beauté afro. 
              Expertise, élégance et bien-être au cœur d'Asnières-sur-Seine.
            </p>
            <div className="flex gap-4">
              <a
                href={siteInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#3E2723] flex items-center justify-center hover:bg-[#C9A96E] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href={siteInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-[#3E2723] flex items-center justify-center hover:bg-[#C9A96E] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-semibold text-white mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-[#D4C4B5] hover:text-[#C9A96E]">Accueil</Link></li>
              <li><Link to="/services" className="text-[#D4C4B5] hover:text-[#C9A96E]">Nos Services</Link></li>
              <li><Link to="/produits" className="text-[#D4C4B5] hover:text-[#C9A96E]">Produits</Link></li>
              <li><Link to="/galerie" className="text-[#D4C4B5] hover:text-[#C9A96E]">Galerie</Link></li>
              <li><Link to="/a-propos" className="text-[#D4C4B5] hover:text-[#C9A96E]">À Propos</Link></li>
              <li><Link to="/contact" className="text-[#D4C4B5] hover:text-[#C9A96E]">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-serif font-semibold text-white mb-6">Nos Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-[#D4C4B5] hover:text-[#C9A96E]">Coiffure Afro</Link></li>
              <li><Link to="/services" className="text-[#D4C4B5] hover:text-[#C9A96E]">Manucure</Link></li>
              <li><Link to="/services" className="text-[#D4C4B5] hover:text-[#C9A96E]">Pédicure</Link></li>
              <li><Link to="/services" className="text-[#D4C4B5] hover:text-[#C9A96E]">Soins Visage</Link></li>
              <li><Link to="/produits" className="text-[#D4C4B5] hover:text-[#C9A96E]">Boutique</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-serif font-semibold text-white mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#C9A96E] flex-shrink-0 mt-0.5" />
                <span className="text-[#D4C4B5] text-sm">{siteInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-[#C9A96E] flex-shrink-0" />
                <a href={`tel:${siteInfo.phone}`} className="text-[#D4C4B5] text-sm">{siteInfo.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-[#C9A96E] flex-shrink-0" />
                <a href={`mailto:${siteInfo.email}`} className="text-[#D4C4B5] text-sm">{siteInfo.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={20} className="text-[#C9A96E] flex-shrink-0 mt-0.5" />
                <div className="text-[#D4C4B5] text-sm">
                  <p> Jeudi-Lundi : {siteInfo.hours.weekdays}</p>
                  <p> Mardi - Mercredi : Fermé </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[#3E2723]">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#A67B5B] text-sm">
              © {new Date().getFullYear()} {siteInfo.name}. Tous droits réservés. <span style={{ marginLeft: 50 }}> TDLstudio</span>

            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/blog" className="text-[#A67B5B] hover:text-[#C9A96E]">Blog</Link>
              <Link to="/mentions-legales" className="text-[#A67B5B] hover:text-[#C9A96E]">Mentions légales</Link>
              <Link to="/cgu" className="text-[#A67B5B] hover:text-[#C9A96E]">CGU</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
